"use client";
import { Box } from "@chakra-ui/react";
import Image from "next/image";
import { Balancer } from "react-wrap-balancer";
import { useHeadingVariant, useTextVariant } from "@/theme/hooks/useSectionStyle";
import { Heading, Text } from "@/elements";
import { APPLICATIONS_CONSTANTS } from "./constants";

const AppCard = ({ title, content, bgcolor, image }) => {
  const Textvariant = useTextVariant();
  return (
    <Box
      shadow={"md"}
      bg="white"
      borderRadius={"10px"}
      border={"1px solid #eee"}
      transition={"0.3s"}
      minH={"380px"}
      display={"flex"}
      flexDir={"column"}
      maxWidth={"360px"}
      _hover={{
        shadow: "lg",
      }}
      gap={"1.5rem"}
    >
      <Box
        width="100%"
        h={{ base: "150px", md: "200px" }}
        position="relative"
        bg={bgcolor}
      >
        <Image
          src={image}
          alt={title}
          fill
          style={{
            objectFit: "contain",
          }}
        />
      </Box>
      <Heading variant={"subTitle3"} px={{ base: 2, md: 4, xl: 6 }}>
        {title}
      </Heading>
      <Text variant={Textvariant} px={{ base: 2, md: 4, xl: 6 }} color={"text.100"}>
        {content}
      </Text>
    </Box>
  );
};

const AppsComponent = () => {
  const HeadingVariant = useHeadingVariant();
  return (
    <Box id="applications">
      <Heading variant={HeadingVariant} mb={8} textAlign={"center"}>
        {APPLICATIONS_CONSTANTS.heading}
      </Heading>
      <Text variant={"label1"} color={"text.100"} mb={8} textAlign={"center"}>
        <Balancer>{APPLICATIONS_CONSTANTS.description}</Balancer>
      </Text>
      <Box
        display="grid"
        gridTemplateColumns={{
          base: "repeat(1, 1fr)",
          sm: "repeat(2, 1fr)",
          md: "repeat(4, 1fr)",
          lg: "repeat(4, 1fr)",
        }}
        gap={6}
      >
        {APPLICATIONS_CONSTANTS.applications.map((app, index) => (
          <AppCard key={index} {...app} />
        ))}
      </Box>
    </Box>
  );
};
export default AppsComponent;
